import React from 'react';
import { Link } from 'react-router-dom';
import { Mic, Video, Music, Settings, Smartphone, Monitor, Radio } from 'lucide-react';

export default function StudioTest() {
  const studios = [
    {
      name: 'Audio Setup',
      path: '/audio-setup',
      icon: <Settings className="w-8 h-8" />,
      description: 'Test & configure audio input devices',
      color: 'bg-purple-600'
    },
    {
      name: 'Mobile Studio',
      path: '/mobile-studio',
      icon: <Smartphone className="w-8 h-8" />,
      description: 'Mobile-optimized recording studio',
      color: 'bg-amber-600'
    },
    {
      name: 'Multi-Cam Studio',
      path: '/multi-cam-studio',
      icon: <Video className="w-8 h-8" />,
      description: 'Desktop studio with multi-camera support',
      color: 'bg-blue-600'
    },
    {
      name: 'Camera Test',
      path: '/camera-test',
      icon: <Monitor className="w-8 h-8" />,
      description: 'Test camera and audio devices',
      color: 'bg-green-600'
    },
    {
      name: 'Camera Test 2',
      path: '/camera-test-2',
      icon: <Radio className="w-8 h-8" />,
      description: 'Alternative camera test page',
      color: 'bg-red-600'
    },
  ];

  return (
    <div className="min-h-screen bg-black text-white p-4">
      <div className="max-w-lg mx-auto">
        <h1 className="text-3xl font-bold text-center mb-2">Studio Test Page</h1>
        <p className="text-stone-400 text-center mb-6">
          Test audio devices in different studios - No payment required
        </p>

        <div className="space-y-3">
          {studios.map((studio) => (
            <Link
              key={studio.path}
              to={studio.path}
              className={`block p-4 ${studio.color} rounded-xl hover:opacity-90 transition-opacity`}
            >
              <div className="flex items-center gap-4">
                {studio.icon}
                <div>
                  <h2 className="text-xl font-bold">{studio.name}</h2>
                  <p className="text-sm opacity-80">{studio.description}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 p-4 bg-stone-900 rounded-xl">
          <h3 className="font-bold text-amber-400 mb-2">Testing External Audio (Zoom PodTrak)</h3>
          <ol className="text-sm text-stone-300 space-y-2">
            <li>1. Connect your Zoom PodTrak P4 to your iPhone</li>
            <li>2. Try each studio above to see which one detects it</li>
            <li>3. Look for audio input/device selector in each studio</li>
            <li>4. Check if the Zoom appears in the device list</li>
          </ol>
        </div>

        <Link
          to="/"
          className="block mt-6 py-3 bg-stone-800 rounded-xl text-center font-bold"
        >
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}
